import { useFlags } from 'flagsmith/react';

export const useLegacyAppSunsetModalFlag = () => {
  const flags = useFlags(['legacy_app_sunset_modal']);
  return Boolean(flags?.legacy_app_sunset_modal?.enabled);
};
